import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

import './Alert.scss';

type AlertProps = {
  id?: string;
  type?: 'danger' | 'warning' | 'info' | 'success';
  role?: string;
  className?: string;
};

export function Alert({
  children,
  type = 'info',
  role = 'alert',
  className,
  ...other
}: PropsWithChildren<AlertProps>) {
  return (
    <div
      className={classNames('Alert', `Alert--${type}`, className)}
      role={role}
      {...other}
    >
      {children}
    </div>
  );
}
